import { useCallback, useEffect, useRef } from 'react';

// Privacy Policy and Terms of Use pages: start at the top, smooth scrolling for the
// "On this page" list, and scroll padding for the sticky bar (via the "pp-html" class).
const BAR_OFFSET = 96;

export default function useLegalPage(name) {
  const rootRef = useRef(null);
  const log = useCallback((...args) => console.log(`[${name}]`, ...args), [name]);

  useEffect(() => {
    const html = document.documentElement;
    html.classList.add('pp-html');
    window.scrollTo(0, 0);
    log('page shown');
    return () => html.classList.remove('pp-html');
  }, [log]);

  const navTo = useCallback(
    (e) => {
      const a = e && e.currentTarget;
      const id = a ? (a.getAttribute('href') || '').replace('#', '') : '';
      const target = id ? document.getElementById(id) : null;
      if (!target) return;
      e.preventDefault();
      log(`contents: scrolling to #${id}`);
      const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const y = target.getBoundingClientRect().top + window.pageYOffset - BAR_OFFSET;
      window.scrollTo({ top: Math.max(0, y), behavior: calm ? 'auto' : 'smooth' });
    },
    [log]
  );

  return { rootRef, navTo };
}
